;(function () {
  const languageSwitcherConfig = window.themeLanguageSwitcherConfig || {}
  const defaultLanguage = normalizeLanguageCode(languageSwitcherConfig.defaultLanguage) || "en"
  const availableLanguages = Array.isArray(languageSwitcherConfig.availableLanguages)
    ? languageSwitcherConfig.availableLanguages
    : []
  const preferredLanguageStorageKey = "preferred-language"
  const weglotLanguageStorageKey = "wglang"
  const internationalPathSuffix = "int"
  const marketRedirectCookieName = "nidecker-market-target-path"

  function normalizeLanguageCode(language) {
    if (typeof language !== "string") return ""

    return language.trim().toLowerCase().split(/[-_]/)[0]
  }

  function hasLanguage(language, languages) {
    for (let index = 0; index < languages.length; index += 1) {
      if (languages[index] === language) return true
    }

    return false
  }

  function isNideckerHost(hostname) {
    return hostname === "nidecker.com" || hostname.endsWith(".nidecker.com")
  }

  function getCookie(name) {
    const cookies = document.cookie ? document.cookie.split("; ") : []

    for (let index = 0; index < cookies.length; index += 1) {
      const cookie = cookies[index].split("=")

      if (cookie.shift() === name) return decodeURIComponent(cookie.join("="))
    }

    return ""
  }

  function setCookie(name, value, maxAge, path) {
    const cookiePath = typeof path === "string" && path.charAt(0) === "/" ? path : "/"
    let cookieValue = `${name}=${encodeURIComponent(value)}; path=${cookiePath}; SameSite=Lax`

    if (typeof maxAge === "number") cookieValue += `; max-age=${maxAge}`

    document.cookie = cookieValue

    if (isNideckerHost(window.location.hostname)) {
      document.cookie = `${cookieValue}; domain=.nidecker.com`
    }
  }

  function clearCookie(name, path) {
    setCookie(name, "", 0, path)
  }

  const marketTargetPath = getCookie(marketRedirectCookieName)

  if (marketTargetPath && marketTargetPath.charAt(0) === "/") {
    if (window.location.pathname === marketTargetPath.split(/[?#]/)[0]) {
      clearCookie(marketRedirectCookieName)
    } else {
      clearCookie(marketRedirectCookieName)
      window.location.replace(marketTargetPath)
      return
    }
  }

  const knownLanguages = [defaultLanguage]

  for (let index = 0; index < availableLanguages.length; index += 1) {
    const language = normalizeLanguageCode(availableLanguages[index])

    if (language && !hasLanguage(language, knownLanguages)) knownLanguages.push(language)
  }

  const firstSegment = window.location.pathname.split("/")[1] || ""
  const normalizedSegment = firstSegment.toLowerCase()
  let pathLanguage = normalizeLanguageCode(firstSegment)
  const internationalLanguageSegment = `${pathLanguage}-${internationalPathSuffix}`
  const hasPathLanguagePrefix =
    hasLanguage(pathLanguage, knownLanguages) &&
    (normalizedSegment === pathLanguage || normalizedSegment === internationalLanguageSegment)

  if (!hasPathLanguagePrefix) {
    pathLanguage = defaultLanguage
  }

  if (!hasPathLanguagePrefix) {
    clearCookie("wglang", "/")

    for (let index = 0; index < knownLanguages.length; index += 1) {
      const language = knownLanguages[index]

      if (language === defaultLanguage) continue

      clearCookie("wglang", `/${language}`)
      clearCookie("wglang", `/${language}-${internationalPathSuffix}`)
    }
  }

  setCookie("wglang", pathLanguage)

  if (hasPathLanguagePrefix) {
    setCookie("wglang", pathLanguage, undefined, `/${firstSegment}`)

    try {
      window.localStorage.setItem(preferredLanguageStorageKey, pathLanguage)
      window.localStorage.setItem(weglotLanguageStorageKey, pathLanguage)
    } catch {}
  }

  window.themePathLanguage = pathLanguage
})()
